<template>
    <div>
        <b-form-textarea
            v-model="input"
            @input="$emit('input', input.split('\n'))"
        />
    </div>
</template>

<script>
    export default {
        props: ['value'],
        data() {
            return {
                input: this.value.join('\n')
            }
        }
    }
</script>